import React from 'react';
import { FadeIn } from './FadeIn';
import { Headphones, Star } from 'lucide-react';
const tracks = [{
  title: 'The Biological "Why"',
  desc: 'Understanding the Ambush'
}, {
  title: 'The Core Temp Reset',
  desc: 'The 2-Hour Bedtime Drill'
}, {
  title: 'The Cortisol-Melatonin Handshake',
  desc: 'Circadian Alignment'
}, {
  title: 'The Midnight Rescue',
  desc: "What to do when you're already awake"
}, {
  title: 'The Lifestyle Multipliers',
  desc: 'Supplements & Hidden Triggers'
}];
export function WhatYouGet() {
  return <section className="py-24 md:py-32 bg-[#1A2352] relative" data-id="element-216">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-217">
        <FadeIn data-id="element-218">
          <div className="text-center mb-20" data-id="element-219">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#F5D0A9]/10 mb-8" data-id="element-220">
              <Headphones className="w-10 h-10 text-[#F5D0A9]" data-id="element-221" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-white mb-6" data-id="element-222">
              The Full 60-Minute "3:00 AM Sleep Fix" Audiobook
            </h2>
            <p className="text-xl text-slate-400 font-light" data-id="element-223">
              Everything you need to recalibrate your internal thermostat.
            </p>
          </div>
        </FadeIn>

        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12" data-id="element-224">
          <div className="lg:col-span-7 space-y-4" data-id="element-225">
            {tracks.map((track, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-226">
                <div className="flex items-center gap-5 bg-white/[0.03] p-5 md:p-6 rounded-2xl border border-white/10 hover:bg-white/[0.06] transition-colors" data-id="element-227">
                  <div className="bg-[#F5D0A9]/10 w-12 h-12 rounded-full flex items-center justify-center shrink-0 border border-[#F5D0A9]/20" data-id="element-228">
                    <span className="text-[#F5D0A9] font-serif text-lg" data-id="element-229">
                      Track {i + 1}
                    </span>
                  </div>
                  <div data-id="element-230">
                    <h4 className="text-white font-medium text-lg mb-1" data-id="element-231">
                      {track.title}
                    </h4>
                    <p className="text-slate-400 text-sm md:text-base font-light" data-id="element-232">
                      {track.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          <div className="lg:col-span-5 h-full" data-id="element-233">
            <FadeIn delay={0.5} className="h-full" data-id="element-234">
              <div className="bg-gradient-to-br from-[#F5D0A9]/30 via-[#F5D0A9]/5 to-transparent p-[1px] rounded-3xl h-full" data-id="element-235">
                <div className="bg-[#0B1029] p-8 md:p-10 rounded-3xl h-full flex flex-col justify-center relative overflow-hidden" data-id="element-236">
                  <div className="absolute top-0 right-0 w-64 h-64 bg-[#F5D0A9]/10 blur-3xl rounded-full" data-id="element-237" />
                  <Star className="w-12 h-12 text-[#F5D0A9] mb-8 relative z-10" data-id="element-238" />
                  <h3 className="text-sm font-bold tracking-widest text-[#F5D0A9] uppercase mb-4 relative z-10" data-id="element-239">
                    Bonus Included
                  </h3>
                  <p className="text-2xl md:text-3xl font-serif text-white mb-4 relative z-10" data-id="element-240">
                    The 5-Minute "Emergency Drift-Off"
                  </p>
                  <p className="text-slate-400 font-light leading-relaxed relative z-10" data-id="element-241">
                    A guided audio session designed specifically to be played
                    while you are lying in the dark, to settle your nervous
                    system in seconds if you do wake up.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}